export default function initHighlightAnimation() {
    // ==========================================================
    // HIGHLIGHT ANIMATION
    // ==========================================================

    const highlights = document.querySelectorAll(".highlight-marker");

    if (highlights.length) {
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (!entry.isIntersecting) {
                        return;
                    }

                    entry.target.classList.add("is-visible");
                    observer.unobserve(entry.target);
                });
            },
            {
                threshold: 0.5,
            },
        );

        highlights.forEach((highlight) => {
            observer.observe(highlight);
        });
    }
}
